import React, { useState, useEffect, useImperativeHandle,forwardRef } from 'react';
import {Table,Space,message,Popconfirm,Typography} from 'antd'
import { request } from '../../../../../utils/fetch'
import store from '../../../../../store/index'
import '../index.css'
const { Link } = Typography

function BaseTable(props,ref) {
    let path = 'bankPush'
    const { refresh } = props
    const [tableData, setTableData] = useState([])
    const [permissions] = useState(store.getState().userReducer.permissions) // 权限列表
    console.log(permissions.includes(`${path}:push`),999)
    const [queryData,setQueryData] = useState({})
    let pageSize = 20
    const [pagination, setPagination] = useState({
        pageNum: 1,
        pageSize: pageSize,
        total: 0
    })
    useImperativeHandle(ref, () => ({
        // showModal 就是暴露给父组件的方法
        getlist: (val) => {
            console.log(val,'val');
            if(val){
                setQueryData(val)
            }
            setPagination(prev => {
                return {
                    ...prev,
                    pageNum: 1
                }
            })
            const pag = {...pagination}
            pag.pageNum = 1
            console.log(pagination,pag);
            getTableLists(pag,val)
        }
    }));
    
    //获取数据
    const getTableLists = ({pageNum, pageSize},query=queryData) => {
        const params = Object.assign({}, query,{pageNum: pageNum, pageSize: pageSize})
        request.requestGet('/platform/bankPush/getList', params).then((res)=>{
            console.log(res);
            if(res.data.success){
                setTableData(res.data.data.list)
                setPagination(prev => {
                    return {
                        ...prev,
                        total: res.data.data.totalCount
                    }
                })
            }
        })
    }
  
    const columns = [
        { title: '创建时间',dataIndex: 'createTime',width: 160,align: 'center'},
        { title: '名单人数',dataIndex: 'personCount',width: 100,align: 'center' },
        { title: '状态',dataIndex: 'statusName',width: 100,align: 'center' },
        { title: '操作人',dataIndex: 'createUser',width: 120,align: 'center'},
        { 
            title: '操作',width: 180,align: 'center',fixed: 'right',
            render: (text, record) => {
                return (
                    <Space size='middle'>
                        {<Link onClick={() => view(record)}>查看</Link>}
                        {permissions.includes(`${path}:push`)&&record.status==1&&<Popconfirm
                            placement="topRight"
                                title='确定把数据推送到九江的无忧云控平台么？'
                                onConfirm={() => {
                                    submit(record)
                                }}
                                okText='确定'
                                cancelText='取消'
                            >
                                <Link>推送</Link>
                            </Popconfirm>}
                    </Space>
                )
            }
        }
    ]
    useEffect(() => {
        getTableLists(pagination)
    }, [])
     //查看
    const view = (record)=>{
        let query = {
            url:'/admin/bankCardPush/cardPushDetail',
            params:{
                pushNo:record.pushNo
            }
        }
        refresh('cardPushDetail',query)
    }
    //修改
    const submit = (record)=>{  
        const params = {
            pushNo:record.pushNo
        }
        request.requestPost('/platform/bankPush/push', params).then((res)=>{
            console.log(res);
            if(res.data.success){
                message.success(res.data.retMsg)
                getTableLists(pagination)
            }else{
                message.error(res.data.retMsg)
            }
        })
    }
    //分页改变
    const tablePageChange = (pageNum, pageSize) => {
        setPagination(prev => {
            return {
                ...prev,
                pageNum: pageNum
            }
        })
        getTableLists({ pageSize: pageSize, pageNum: pageNum })
    }
    return (
        <Table
            scroll={{ x: '100%', y: 560 }}
            columns={columns}
            rowKey={record => record.id}
            dataSource={tableData}
            pagination={{
                position: ['bottomCenter'],
                total: pagination.total,
                current: pagination.pageNum,
                pageSize: pagination.pageSize,
                showSizeChanger: false,
                showTotal: total => `共 ${total} 条数据`,
                onChange: (pageNum, pageSize) => tablePageChange(pageNum, pageSize)
            }}
        />
    )
}
export default forwardRef(BaseTable)
